module.exports = __webpack_public_path__ + "img/KinokoTable27.e2c04534.jpg";